import TYPES from './types';
import { getSupport } from '../../../api/support';

const loadingSearchToggle = () => ({
  type: TYPES.loadingFormSearch,
});

export const searchArticles = params => {
  return dispatch => {
    dispatch(loadingSearchToggle());
    getSupport(params)
      .then(response =>
        dispatch({
          type: TYPES.searchSuccess,
          payload: response,
        })
      )
      .then(() => dispatch(loadingSearchToggle()))
      .catch(() => dispatch({ type: TYPES.searchError }))
  }
};
